import { SET_SERVICE, RESET_SERVICE } from "../actions/service";

const initialState = {
  internet: [],
  phone: [],
  wifiRouter: [],
  shipping: null
};

const service = (state = initialState, action) => {
  switch (action.type) {
    case SET_SERVICE:
      return { ...action.payload };
    case RESET_SERVICE:
    return initialState;
    default:
      return state;
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/store/reducers/service.js